/** Clamps a badge counter so a large unread count cannot widen its pill. */
export function formatBadgeCount(count: number): string {
  return count > 99 ? '99+' : String(count);
}
